import { render, staticRenderFns } from "./CobrancaModal.vue?vue&type=template&id=42a2416e&scoped=true&"
import script from "./CobrancaModal.vue?vue&type=script&lang=js&"
export * from "./CobrancaModal.vue?vue&type=script&lang=js&"
import style0 from "./CobrancaModal.vue?vue&type=style&index=0&id=42a2416e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a2416e",
  null
  
)

export default component.exports